import { render } from "./BlogItem.vue?vue&type=template&id=00c7f65a&scoped=true"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"

import "./BlogItem.vue?vue&type=style&index=0&id=00c7f65a&lang=postcss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c7f65a"]])

export default __exports__